<template>
  <div class="card-new p-3">
    <div class="card-header">
      <div class="flex justify-between">
        <div>
          <h2 class="card-heading">Today's Weather Forecast</h2>
        </div>
        <div class="card-subheading">
        </div>
      </div>
    </div>
    <div class="card-content flex text-center content-center justify-between">
      <div class="flex-grow mt-3 animate-pulse">
        <i class="fal text-slate-700 text-3xl " v-bind:class="icon"></i>
      </div>
      <div class="flex-grow "><span class="text-lg font-semibold text-slate-800">{{ data.main.temp }}°</span> <br>
        <span>Temperature</span></div>
      <div class="flex-grow "><span class="text-lg font-semibold text-slate-800">{{ data.wind.speed }}</span> <br>
        <span>Wind Speed</span></div>
      <div class="flex-grow "><span class="text-lg font-semibold text-slate-800">{{ data.wind.deg }}</span> <br> <span>Wind Direction</span>
      </div>
      <div class="flex-grow "><span class="text-lg font-semibold text-slate-800">{{ data.main.humidity }}</span> <br>
        <span>Humidity</span></div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import axios from "axios";

@Component({})
export default class WeatherForecast extends Vue {

  private temparature = 2;
  private windspeed = 2;
  private direction = 2;
  private humidity = 2;
  private data = {
    main: {
      temp: 0,
      humidity: 0
    },
    wind: {
      speed: 0,
      deg: 0
    },
    weather: [
      {
        main: 'Rain'
      }
    ]
  };
  private icon = 'fa-sun-cloud';


  mounted() {
    this.getOverallStatistics();
  }

  getOverallStatistics() {
    axios.get('https://admin.port.mv/api/current-weather').then(resp => {
      this.data = resp.data.data.data;


      const main = this.data.weather[0].main;

      switch (main) {
        case 'Clouds':
          this.icon = 'fa-clouds';
          break;
        case 'Thunderstorm':
          this.icon = 'fa-thunderstorm';
          break;
        case 'Drizzle':
          this.icon = 'fa-cloud-sun-rain';
          break;
        case 'Rain':
          this.icon = 'fa-cloud-rain';
          break;
        case 'Clear':
          this.icon = 'fa-sun-cloud';
          break;
        default:
          this.icon = 'fa-sun-cloud';
          break;
      }

    });
  }

}
</script>
